import regularExpressions from './regular-expressions';
import navigation from './navigation';
import attributes from './attributes';
import actionTypes from './action-types';
import settings from './settings';
import globalIds from './global-ids';

export default {
  GLOBAL_TAG_NAME: 'ws-global',
  regularExpressions,
  navigation,
  attributes,
  actionTypes,
  globalIds,
  settings,
};
